<template>
  <div
    class="form-group"
    :class="{
      'input-group': hasIcon,
      'input-group-focus': focused,
    }"
  >
    <slot name="label">
      <label v-if="label" class="control-label">{{ label }}</label>
    </slot>
    <slot name="addonLeft">
      <span v-if="addonLeftIcon" class="input-group-prepend">
        <div class="input-group-text">
          <i :class="addonLeftIcon"></i>
        </div>
      </span>
    </slot>
    <slot>
      <input
        :value="value"
        v-bind="$attrs"
        v-on="listeners"
        class="form-control"
        :class="{ error: !focused && error }"
        aria-describedby="addon-right addon-left"
      />
    </slot>
    <slot name="addonRight">
      <span v-if="addonRightIcon" class="input-group-append">
        <div class="input-group-text">
          <i :class="addonRightIcon"></i>
        </div>
      </span>
    </slot>
    <slot name="helperText"></slot>
  </div>
</template>
<script>
import validatable from "../validatable";
export default {
  name: "ttw-input",
  inheritAttrs: false,
  mixins: [validatable],
  props: {
    label: String,
    value: {
      type: [String, Number],
    },
    addonRightIcon: String,
    addonLeftIcon: String,
    required: {
      type: Boolean,
      default: false,
    },
    keyValidator: {
      type: Function,
      default: () => null,
    },
    inputValidator: {
      type: Function,
      default: null,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  data() {
    return {
      focused: false,
    };
  },
  computed: {
    hasIcon() {
      const { addonRight, addonLeft } = this.$slots;
      return (
        addonRight !== undefined ||
        addonLeft !== undefined ||
        this.addonRightIcon !== undefined ||
        this.addonLeftIcon !== undefined
      );
    },
    listeners() {
      return {
        ...this.$listeners,
        blur: this.onBlur,
        input: this.onInput,
        focus: this.onFocus,
      };
    },
  },
  methods: {
    onInput(evt) {
      if (this.keyValidator != null) {
        if (evt.data && this.keyValidator(evt.data) === false) {
          evt.target.value = this.value;
          return;
        }
      }
      if (
        this.inputValidator === null ||
        this.inputValidator(evt.target.value)
      ) {
        this.$emit("input", evt.target.value);
      }
    },
    onFocus() {
      this.focused = true;
    },
    onBlur() {
      this.focused = false;
    },
  },
};
</script>
